<template>
    <div>
        <h2 class="m-0 h1 text-uppercase">{{$t('eventos.sesiones_selecion')}}</h2>
        <div class="subtitle h3 light mb-3 mb-lg-4 mb-lg-5">
            {{$t('eventos.sesiones_elige')}}
        </div>
        <b-row>
            <template v-for="(sesion, index) in sesiones">
                <b-col lg="3" md="6" sm="12" :key="index" class="p-1 text-center">
                    <router-link 
                        v-if="sesion.entradas_libres"
                        :to="{
                            name: 'front.eventos.show.slug',
                            params: {
                                event_id: event.id,
                                sesion_id: sesion.id,
                                slug: toSlug(event)
                            },
                        }"
                        :key="index"
                        class="button large-button effect-button mr-md-3 mb-md-0 mb-2"
                    >
                        <span>{{ sesion.fecha }}</span>
                    </router-link>
                    <button 
                        v-else
                        :key="index"
                        class="disabled button large-button effect-button mr-md-3 mb-md-0 mb-2"
                    >
                        <span>{{ sesion.fecha }}</span>
                        <span>{{$t('eventos.no_disponible')}}</span>
                    </button>
                </b-col>
            </template>
        </b-row>
    </div>

</template>

<script>
import CapitalizationUtils from '@/utils/CapitalizationUtils'
export default {
    props: ['event', 'sesiones'],
    methods: {
        toSlug(event) {
            return CapitalizationUtils.toKebabCase(event.name)
        },
    }
}
</script>